import { httpClient } from 'api';
import { SessionAgenda } from 'types/SessionAgenda';

export const sessionAgendaApi = {
	getSessionAgendaForSessionId: (sessionId: number, pairId: number, applicationId: number) =>
		httpClient.get<SessionAgenda>(`/session-agenda/session/${sessionId}/${pairId}/${applicationId}`),
};
